/**
 * Reads a chosen file's length from its media metadata so the pay-as-you-go notice can
 * appear before the job starts. Returns null while unknown or if the browser cannot read it.
 */
import { useEffect, useState } from 'react';

export function useMediaDuration(file: Blob | null): number | null {
  const [state, setState] = useState<{ file: Blob | null; seconds: number | null }>({ file: null, seconds: null });

  useEffect(() => {
    if (!file || typeof document === 'undefined' || typeof URL.createObjectURL !== 'function') return;
    const url = URL.createObjectURL(file);
    const el = document.createElement('video'); // plays audio and video containers alike
    el.preload = 'metadata';
    const done = (seconds: number | null) => setState({ file, seconds });
    el.onloadedmetadata = () => done(Number.isFinite(el.duration) && el.duration > 0 ? el.duration : null);
    el.onerror = () => done(null);
    el.src = url;
    return () => {
      el.onloadedmetadata = null;
      el.onerror = null;
      el.removeAttribute('src');
      URL.revokeObjectURL(url);
    };
  }, [file]);

  return state.file === file ? state.seconds : null;
}
